import { cn } from "web-design-system";
import { BannerView, getCropStyle } from "./crop";

/** Shows a banner inside a 5:4 box. The caller sizes the box. */
export function BannerImage({
  banner,
  className,
}: {
  banner: BannerView;
  className?: string;
}) {
  return (
    <div className={cn("relative overflow-hidden", className)}>
      <img
        src={banner.url}
        alt=""
        draggable={false}
        className={cn(
          "absolute max-w-none select-none",
          !banner.framing && "inset-0 size-full object-cover"
        )}
        style={
          banner.framing &&
          getCropStyle(banner.framing.crop, banner.framing.imageAspectRatio)
        }
      />
    </div>
  );
}
